import React from 'react';
import { CssTheme } from '../types/generatorV2';

export default function ThemeExample({ theme, compact = false }: { theme?: CssTheme; compact?: boolean }) {
  const primary = theme?.previewColors?.primary || '#2563eb';
  const secondary = theme?.previewColors?.secondary || '#0f766e';
  const background = theme?.previewColors?.background || '#fff';
  const ink = theme?.isDark ? '#f1f5f9' : '#172033';
  return <div className={`wp-themeExample ${compact ? 'is-compact' : ''}`} style={{ background, color: ink }} aria-hidden={compact || undefined}>
    <div className="wp-themeExampleNav"><strong style={{color: primary}}>Ваш бренд</strong><span>О нас · Услуги · Контакты</span></div>
    <div className="wp-themeExampleHero"><small style={{color: secondary}}>РЕШЕНИЯ ДЛЯ ВАШИХ КЛИЕНТОВ</small><strong>Ваша идея.<br />Выразительный сайт.</strong><p>Цвета, текст и акценты работают вместе.</p><span className="wp-exampleButton" style={{background: primary, color: '#fff'}}>Узнать больше →</span></div>
    <div className="wp-themeExampleCards">{['Опыт', 'Подход', 'Результат'].map(title => <div key={title} style={{borderColor: secondary}}><strong>{title}</strong><i style={{background: ink}}/><i style={{background: ink}}/></div>)}</div>
  </div>;
}
